<div class="table-header">
  <p *ngFor="let column of settings.columns" [innerHtml]="column.text" [style.flex]="column.flex" [ngClass]="column.cssClass"></p>
</div>

<div class="table-row" *ngFor="let row of settings.data; let i = index;">
  <div *ngFor="let rowCol of getRowColumns(row); let c = index;" [style.flex]="rowCol.flex" [ngClass]="rowCol.cssClass">
    <p [innerHtml]="rowCol.value" *ngIf="settings.columns[c].type == 'text'"></p>
    <mat-icon *ngIf="settings.columns[c].type == 'icon'" [innerHtml]="rowCol.value"></mat-icon>
  </div>
</div>